/**
 * Télécharge un fichier depuis une URL cross-origin via un blob,
 * ce qui contourne la restriction du navigateur sur l'attribut `download`
 * et permet de contrôler le nom du fichier téléchargé.
 */
export async function downloadFile(
  url: string,
  filename: string
): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(blobUrl);
}
